import { Content, Item } from '@radix-ui/react-context-menu'
import styled from 'styled-components'

import { ZIndex } from '../../../constants/ZIndex'

export const StyledNewContextMenuContent = styled(Content)`
  min-width: 200px;
  background-color: ${props => props.theme.colors.background.base};
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings.small};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: ${ZIndex.MAX};
`

export const StyledNewContextMenuItem = styled(Item)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacings.small};
  padding: ${props => props.theme.spacings.small};
  position: relative;
  user-select: none;
  cursor: pointer;

  &[data-disabled] {
    opacity: ${props => props.theme.opacities.disabled};
    pointer-events: 'none';
    cursor: not-allowed;
  }

  &[data-highlighted] {
    background-color: ${props => props.theme.colors.neutral.lighter};
  }
`
